import angular from 'angular';
import uiRouter from '@uirouter/angularjs';
import template from './blockpassword.template.html';
import controller from './blockpassword.controller';
import './blockpassword.style.scss';

/**
 * Block Email Verification View Module
 */
export default angular.module('blockpassword', [uiRouter])
	.config(($stateProvider, $urlRouterProvider) => {
		"ngInject";
		$stateProvider.state('blockpassword', {
			url: '/blockpassword/:token/:idPessoa/:finalizouProcesso',
			component: 'blockpassword'
		});
	})

	.component('blockpassword', {
		bindings: {},
		template,
		controller
	}).name;




// WEBPACK FOOTER //
// ./src/app/components/views/blockpassword/blockpassword.js